export class YAxisHelper {
  static getNearestOrderOfMagnitdue(value: number) {
    if (value === null || typeof value === 'undefined') {
      throw new Error('Cannot calculate nearest order of magnitude if !value');
    }

    var order = Math.floor(Math.log(value) / Math.LN10 + 0.000000001);
    return Math.pow(10, order);
  }
}